export function getCommissionValues(data){
    let cvv = data.payProcessor.showCVV;
    if(cvv == null){
        cvv=false;
    }
    let montoFijoMetodoPago = 0;
    let montoPorcentajeMetodoPago = 0;
    let montoServicio = 0;
    let discountArray = [];
    const totalCommission = data.total;
    const totalPayMethod = data.totalPayMethod;
    const commissionByService = data.commissionByService;
    const payProcessor = data.payProcessor

    data.detail.map(function(item, key) {
        switch (key) {
        case 0:
            montoFijoMetodoPago = item.amount;
            break;
        case 1:
            montoPorcentajeMetodoPago = item.value
            break
        case 2:
            montoFijoMetodoPago =  montoFijoMetodoPago * (1 + item.value/100)
            break
        case 3:
            montoPorcentajeMetodoPago =  (montoPorcentajeMetodoPago) * (1 + item.value/100)
            break
        case 4:
            montoServicio = item.amount
            break
        case 5:
            montoServicio =  montoServicio * (1 + item.value/100)
            break
        default:
            break
        }
    });


    /*console.log([{
        montoFijoMetodoPago, 
        montoPorcentajeMetodoPago,
        montoServicio, 
        cvv
    }], "Result")*/
    if(data.discount){
        discountArray = data.discount;
    }

    return [{
        "comisionMetodoPagoFijo": montoFijoMetodoPago, 
        "comisionMetodoPagoPorcentaje": montoPorcentajeMetodoPago,
        "comisionServicio": montoServicio, 
        "cvv": cvv,
        "discountArray": discountArray,
        "totalCommission": totalCommission,
        "totalPayMethod": totalPayMethod,
        "commissionByService": commissionByService,
        "payProcessor": payProcessor
    }];
}